/**
 * Venue taxonomy — single source of truth for the 15 venue types used by:
 *   • BusinessRegister.js
 *   • VenueInviteSheet.js
 *   • VenuePartnerPicker.js (category-aware filtering — backend-driven)
 *
 * Keep in sync with /app/backend/lib/venue_categories.py — VENUE_TYPES.
 */
export const VENUE_TYPES = [
  'Coffee Shop',
  'Restaurant',
  'Gym',
  'Yoga Studio',
  'Wellness Center',
  'Coworking Space',
  'Art Studio',
  'Museum/Gallery',
  'Entertainment Venue',
  'Sports Club',
  'Outdoor Experience',
  'Hotel/Lounge',
  'Music Studio',
  'Class / Workshop Space',
  'Other',
];

/** UAE-only emirate list for v1. */
export const UAE_CITIES = [
  'Abu Dhabi', 'Dubai', 'Sharjah', 'Ajman',
  'Ras Al Khaimah', 'Fujairah', 'Umm Al Quwain', 'Al Ain',
];
